import { render, staticRenderFns } from "./BackendArticlePage.vue?vue&type=template&id=c87a8998&scoped=true&"
import script from "./BackendArticlePage.vue?vue&type=script&lang=js&"
export * from "./BackendArticlePage.vue?vue&type=script&lang=js&"
import style0 from "./BackendArticlePage.vue?vue&type=style&index=0&id=c87a8998&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87a8998",
  null
  
)

export default component.exports